import { render, staticRenderFns } from "./NlpLock.vue?vue&type=template&id=b201c068"
import script from "./NlpLock.vue?vue&type=script&lang=js"
export * from "./NlpLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports